import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails8 = () => {
  const zsbData = {
    title: "Utpann ZSB",
    category: "Zinc Solubilizing Bacteria",
    image: "/assets/Product/img8.png",
    description:
      "ZSB (Zinc Solubilizing Bacteria) helps convert insoluble zinc in soil into an available form for plant uptake. It improves zinc nutrition, leading to better root growth, chlorophyll formation, and overall plant vigor. Regular use of ZSB enhances crop yield and quality while improving long-term soil health.",
    price: "500",
    priceNote: "Per 500gm Pack (Gujarat) (Inc GST)",
    recommendations: ["All Crops", "Improve Zinc Availability", "Boost Yield!"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      { label: "Total viable count", value: "CFU minimum 5x10(7)" },
      {
        label: "Contamination Level",
        value: "No Contamination at 10(5) dilutions",
      },
      { label: "pH", value: "5.0-7.0" },
      {
        label: "Efficiency Character",
        value:
          "The strain should be capable of solubilizing at least 20mg/liter",
      },
    ],
    packaging: [
      { label: "Bulk", value: "1000 MT FIBC" },
      { label: "Standard Pack", value: "500gm" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Enhances zinc availability in soil",
      "Improves root development and plant vigor",
      "Increases nutrient uptake efficiency",
      "Supports sustainable agriculture with eco-friendly biofertilization",
      "Enhance microbial activity in the soil",
      "Promotes early seed germination and plant establishment",
      "Improves soil structure and fertility overtime",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={zsbData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails8;
